import { Menu, MenuItem, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from "@mui/material";
import { ASButton } from "../../shared/as-button/as-button";
import './user-api-key.scss'
import styles from "../../styles/_exports.module.scss";
import MoreVertIcon from '@mui/icons-material/MoreVert';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';


const UserAPIKey = (props) => {
    const { keyList, apiKeyListHeader, isMenuOpen, enchorEl, selectedMenuIndex } = props.state;

    return (
        <>
            <div className="collections-header-div">

                <div className="data-name-div">
                    <div>
                        <span>Total <span>{keyList?.length}</span></span>
                        <label>API KEYS</label>
                    </div>
                </div>

                <div className="search-btn-div">

                    <div className="add-new-btn-data">

                        <ASButton sx={{ paddingLeft: "15px", paddingRight: "15px" }}
                            onClick={(e) => props.onShowAddNewPopUp(e)}
                            rounded={true} primary={true}
                            variant="contained"
                        >
                            <i className="plus-svg">+</i> ADD NEW
                        </ASButton>

                    </div>

                </div>

            </div>
            <div className="user-key-paper-group">
                <Paper className="user-key-paper" sx={{ height: "75vh" }}>
                    <div>
                        <TableContainer className="scriptTableHeight">

                            <Table
                                aria-labelledby="tableTitle"
                                size='medium'
                                className="user-key-table"
                            >
                                <TableHead>

                                    <TableRow sx={{ position: "sticky", top: 0, zIndex: 1, backgroundColor: "white" }}>
                                        {
                                            apiKeyListHeader?.map((dataHead, index) => {

                                                return (
                                                    <TableCell
                                                        key={`data-coll-header ${index}`}
                                                        align='left'
                                                        sx={{ color: styles.secondaryColor, fontWeight: styles.semiBold }}
                                                        scope="row"
                                                    >
                                                        {dataHead?.headerTitle}
                                                    </TableCell>
                                                )
                                            })
                                        }
                                    </TableRow>

                                </TableHead>
                                <TableBody>
                                    {
                                        (keyList)?.map((data, index) => {
                                            return (
                                                <TableRow
                                                    hover
                                                    onClick={(event) => props?.onShowKeyHistoryPopUp(event, data)}
                                                    key={`filtered-coll ${index}`}
                                                    className='collection-row'
                                                >

                                                    <TableCell
                                                        align="left"
                                                        sx={{ color: styles.mutedColor }}
                                                    >
                                                        <div className="flex-div-cell">
                                                            {data?.name}
                                                        </div>
                                                    </TableCell>

                                                    {/* <TableCell align="left" sx={{ color: styles.mutedColor }}>
                                                        <div className="key-row-container">
                                                            <span className="fixed-width-key">{data?.key}</span>
                                                            <ContentCopyIcon
                                                                fontSize="small"
                                                                titleAccess="Copy key"
                                                                onClick={(event) => {
                                                                    event.stopPropagation();
                                                                    props.handleCopyKey(data?.key);
                                                                }}
                                                                className="copy-icon"
                                                            />
                                                        </div>
                                                    </TableCell> */}

                                                    <TableCell
                                                        align="left"
                                                        sx={{ color: styles.mutedColor }}
                                                    >
                                                        <div className="flex-div-cell">
                                                            {data?.key?.length > 35 ? `${data.key.slice(0, 35)}` : data.key}
                                                        </div>
                                                    </TableCell>

                                                    <TableCell
                                                        align="left"
                                                        sx={{ color: styles.mutedColor }}
                                                    >
                                                        <div className="flex-div-cell">
                                                            {data?.createdDateTime ? data?.createdDateTime?.split('T')[0] : ''}
                                                        </div>
                                                    </TableCell>

                                                    <TableCell align="left" sx={{ color: styles.mutedColor }}>
                                                        <MoreVertIcon
                                                            id={`${String(index)}+vertIcon`}
                                                            aria-controls={isMenuOpen ? `${String(index)}+user-key` : undefined}
                                                            aria-haspopup="true"
                                                            aria-expanded={isMenuOpen ? 'true' : undefined}
                                                            onClick={(event) => props.openMenuOption(event, true, index)}
                                                            className='edit-user-icon'
                                                        >
                                                            Dashboard
                                                        </MoreVertIcon>

                                                        <Menu
                                                            id={`${String(index)}+menu`}
                                                            aria-labelledby={index}
                                                            anchorEl={selectedMenuIndex === index ? enchorEl : null}
                                                            open={selectedMenuIndex === index ? isMenuOpen : false}
                                                            onClose={(event) => props.closeMenuOption(event)}
                                                            anchorOrigin={{ vertical: 'top', horizontal: 'left', }}
                                                            transformOrigin={{ vertical: 'top', horizontal: 'left', }}
                                                            className='edit-user-menu'
                                                        >
                                                            <MenuItem onClick={(event) => { props?.onShowKeyHistoryPopUp(event, data) }}>Show History</MenuItem>
                                                            <MenuItem onClick={(event) => { props?.onKeyDelete(event, data) }}>Delete Key</MenuItem>
                                                        </Menu>
                                                    </TableCell>

                                                </TableRow>
                                            );
                                        })
                                    }
                                </TableBody>
                            </Table>
                        </TableContainer>
                    </div>
                </Paper>
            </div>
        </>
    )
}
export default UserAPIKey;